<script>
import { $themeConfig } from '@themeConfig'
export default {
    computed: {
        link() {
            return $themeConfig.app.privacyPolicyLink;
        },
        translation() {
            if (this.$i18n.locale === 'sv') {
                return 'Integritetspolicy';
            }

            return 'Privacy policy';
        }
    }
}
</script>

<template>
    <span><a :href="link" target="_blank">{{ translation }}</a></span>
</template>
